import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const TooltipMessage = ({
  heading,

  heading1,
  message,
  message2,
  message3,
  message4,
  Image,
  link,
  buttonClass = "",
  website,
  src,
}) => {
  const { t } = useTranslation();

  return (
    <OverlayTrigger
      trigger="click"
      placement="auto"
      rootClose={true}
      overlay={
        <Tooltip
          className="fontSize14Medium custom-green-tooltip"
          id="meter-id-tooltip"
        >
          <div>
            {heading && <div className="mb-1 fw-bold">{t(heading)}</div>}

            <p>{message && t(message)}</p>
            {heading1 && <div className="mb-1 fw-bold">{t(heading1)}</div>}

            <p>{message2 && t(message2)}</p>
            <p>{message3 && t(message3)}</p>
            <p>
              {message4 && t(message4)}{" "}
              {link && website && (
                <a
                  href="https://www.vnbdigital.de/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-light-blue text-decoration-none"
                >
                  {t(website)}
                </a>
              )}
            </p>
            {Image && (
              <div className="mt-2 mb-2">
                {typeof Image === "string" ? (
                  <img src={Image} alt="tooltip-img" className="img-fluid" />
                ) : (
                  <Image />
                )}
              </div>
            )}
          </div>
        </Tooltip>
      }
    >
      <button
        className={`border-0 bg-transparent cursor-pointer custom-tooltop-button custom-pink-button ms-2 ${buttonClass}`}
        type="button"
      >
        <img
          src={src || require("../../assets/images/info.png")}
          alt="Info"
          className="width22 height22 object-fit"
        />
      </button>
    </OverlayTrigger>
  );
};
